import React, { useCallback, useEffect, useState } from 'react'
import { DemoAccountDetails } from 'api/Clients/Types/DemoAccountDetails'
import { WelcomeAccountDetails } from 'api/Clients/Types/WelcomeAccountDetails'
import { PlatformTransactionTypeDto } from 'api/Trading-Accounts/Types/PlatformTransactionTypeDto'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchInstrumentsAction } from 'store/trading-accounts/trading-accounts.actions'
import { PageQuery } from 'utils/api'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'
import { isEmpty } from 'utils/is-empty'

import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import { WelcomeTradingAccountNavigation } from '../Navigation/WelcomeTradingAccountNavigation'
import TradingAccountPlatformTransactionDetailsTable from './TradingAccountPlatformTransactionDetailsTable'

interface Props {
  data: DemoAccountDetails | WelcomeAccountDetails
}

const WelcomeTradingAccountPlatformTransactionDetailsPage: React.FC<Props> = ({
  data: tradingAccount,
}) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const dispatch = useAppDispatch()

  const [gridQuery, setGridQuery] = useState<PageQuery>({})
  const [platformTransactionTypes, setPlatformTransactionTypes] = useState<
    PlatformTransactionTypeDto[]
  >([])

  const symbols = useAppSelector((state) => state.tradingAccounts.instruments)

  const fetchData = useCallback(() => {
    return tradingAccountsApiClient.getWelcomeTradingAccountPlatformTransaction(tradingAccount.id, {
      ...gridQuery,
      skipCount: gridQuery.skipCount ?? true,
    })
  }, [tradingAccount.id, gridQuery]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading } = useFetchOne(fetchData)

  const getPlatformTransactionTypes = async () => {
    const response = await tradingAccountsApiClient.getPlatformTransactionTypes(
      tradingAccount.accountGroup.platformType.id
    )

    setPlatformTransactionTypes(response)
  }
  useEffect(() => {
    if (isEmpty(symbols)) {
      dispatch(fetchInstrumentsAction(tradingAccountsApiClient))
    }
    getPlatformTransactionTypes()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGridChange = (pageQuery: PageQuery) => {
    setGridQuery(pageQuery)
  }

  return (
    <React.Fragment>
      <WelcomeTradingAccountNavigation
        data={tradingAccount}
        isEdit={false}
        tab={TradingAccountTab.PlatformTransactions}
      />
      <TradingAccountPlatformTransactionDetailsTable
        platformTransactionTypes={platformTransactionTypes}
        platformTransactions={data}
        gridQuery={gridQuery}
        isLoading={isLoading}
        onChange={handleGridChange}
      />
    </React.Fragment>
  )
}

export default WelcomeTradingAccountPlatformTransactionDetailsPage
